module.exports = __webpack_public_path__ + "img/course_review1.55fa0ec9.png";